module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#cinema",
      toString: function () {
        return this.url;
      }
    }